import { useScanDataMissingStoresStoreLevelDetailsQuery } from '@occc/graphql';
import {
  usePaginatedQuery,
  PaginationInfo,
  PaginationHandler,
} from '@occc-app/hooks/usePaginatedQuery';

type UseScanDataMissingStoresStoreLevelDetailsParams = {
  submissionDateEquals: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  search?: string;
};

export const useScanDataMissingStoresStoreLevelDetails = ({
  submissionDateEquals,
  paginationInfo,
  onPageChange,
  search,
}: UseScanDataMissingStoresStoreLevelDetailsParams) => {
  return usePaginatedQuery(
    useScanDataMissingStoresStoreLevelDetailsQuery,
    'scanDataMissingStoresStoreLevelDetails.pageInfo',
    undefined,
    {
      variables: {
        filter: {
          submissionDateEquals,
          siteAccountSubmitterSearch: search,
        },
      },
    },
    paginationInfo,
    onPageChange,
  );
};
